/* =====================================================================
   EI POPUP WELCOME V3 — sprint 2026-05-13
   Pattern : form natif {% form 'customer' %} avec contact[email] + contact[tags]
   Logique :
     - Trigger 15s sur template index (gere cote Liquid)
     - 4 cas cookie : A=deja inscrit / B=1ere visite / C1=retour avec rayon / C2=cooldown 7j
     - Phase 1 (rayon) → Phase 2 (email avec titre adapte) → Success post-redirect
     - Detection ?welcome=ok au reload → affiche success state
     - Detection form.errors dans DOM (Liquid render) → affiche phase 2 directement
     - A11y : focus trap, Escape close, ARIA labels
     - Tracking GA4 : popup_view, popup_rayon_choice, popup_submit_click,
       popup_submit_success, popup_close
   ===================================================================== */
(function () {
  'use strict';

  var POPUP_ID = 'ei-popup-welcome';
  var COOKIE_CLOSED = 'ei_popup_closed_at';
  var COOKIE_SUBSCRIBED = 'ei_subscribed';
  var LS_RAYON = 'ei_popup_rayon';

  var root = document.getElementById(POPUP_ID);
  if (!root) return;

  // === CONFIG depuis data-attributes ===
  var DELAI = parseInt(root.dataset.delai, 10) || 15;
  /* 2026-09-06 — delai propre au mobile. 0 (defaut) = aucun minuteur sur mobile,
     c'est le defilement a 45 % qui declenche. Pas de `|| 0` : on veut distinguer
     « regle a 0 » de « attribut absent », et les deux doivent donner 0 ici. */
  var DELAI_MOBILE = parseInt(root.dataset.delaiMobile, 10);
  if (isNaN(DELAI_MOBILE) || DELAI_MOBILE < 0) { DELAI_MOBILE = 0; }
  var COOLDOWN_DAYS = parseInt(root.dataset.cooldownDays, 10) || 7;
  var RAYON_DAYS = parseInt(root.dataset.localstorageDays, 10) || 30;
  var VISIBLE_DESKTOP = root.dataset.visibleDesktop !== 'false';
  var VISIBLE_MOBILE = root.dataset.visibleMobile !== 'false';
  var COHORT_TAG = root.dataset.cohortTag || '';

  // === DOM REFS ===
  var modal = root.querySelector('.ei-popup-modal');
  var phase1 = root.querySelector('[data-phase="1"]');
  var phase2 = root.querySelector('[data-phase="2"]');
  var phaseSuccess = root.querySelector('[data-phase="success"]');
  var closeBtns = root.querySelectorAll('[data-action="close"]');
  var rayonBtns = root.querySelectorAll('.ei-popup-rayon-btn');
  var phase2Title = root.querySelector('[data-phase2-title]');
  var phase2TitresJson = root.querySelector('[data-phase2-titres]');
  var tagsInput = root.querySelector('[data-popup-tags-input]');
  var emailInput = root.querySelector('[data-popup-email-input]');
  var submitBtn = root.querySelector('[data-popup-submit-btn]');
  var errorEl = root.querySelector('[data-popup-error]');
  var honeypot = root.querySelector('input[name="contact[fax]"]');
  var form = root.querySelector('form');

  // === COOKIE HELPERS ===
  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = name + '=' + encodeURIComponent(value) + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }
  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }
  function lsSet(key, value, days) {
    try {
      var item = { v: value, e: Date.now() + days * 24 * 60 * 60 * 1000 };
      localStorage.setItem(key, JSON.stringify(item));
    } catch (e) {}
  }
  function lsGet(key) {
    try {
      var raw = localStorage.getItem(key);
      if (!raw) return null;
      var item = JSON.parse(raw);
      if (Date.now() > item.e) { localStorage.removeItem(key); return null; }
      return item.v;
    } catch (e) { return null; }
  }

  // === GA4 ===
  function track(eventName, params) {
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, Object.assign({ event_category: 'popup_welcome', popup_version: 'v3' }, params || {}));
    }
    if (window.dataLayer && Array.isArray(window.dataLayer)) {
      window.dataLayer.push(Object.assign({ event: eventName, popup_version: 'v3' }, params || {}));
    }
  }
  // Events normalises EI (dimensions custom GA4 : ei_action, ei_source, ei_product)
  function trackEi(eventName, action, extra) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({
      event: eventName,
      ei_action: action,
      ei_source: 'home',
      ei_version: 'v3'
    }, extra || {}));
  }

  // === DEVICE CHECK ===
  function isMobile() { return window.matchMedia('(max-width: 767px)').matches; }
  function isAllowedOnDevice() {
    if (isMobile() && !VISIBLE_MOBILE) return false;
    if (!isMobile() && !VISIBLE_DESKTOP) return false;
    return true;
  }

  // === SHOW / HIDE PHASES ===
  function showPhase(name) {
    [phase1, phase2, phaseSuccess].forEach(function (el) {
      if (!el) return;
      if (el.getAttribute('data-phase') === name) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
  }
  function openOverlay() {
    root.removeAttribute('hidden');
    root.setAttribute('data-active', 'true');
    document.body.style.overflow = 'hidden';
    trapFocus();
  }
  function closeOverlay(reason) {
    root.setAttribute('data-active', 'false');
    setTimeout(function () {
      root.setAttribute('hidden', '');
      document.body.style.overflow = '';
    }, 300);
    if (reason === 'manual') {
      setCookie(COOKIE_CLOSED, String(Date.now()), COOLDOWN_DAYS);
      // Event normalise EI — dismiss sans soumission
      trackEi('ei_popup_welcome_dismiss', 'popup_dismiss', { dismiss_reason: 'manual' });
    }
    if (lastFocused && typeof lastFocused.focus === 'function') {
      lastFocused.focus();
    }
  }

  // === FOCUS TRAP ===
  var lastFocused = null;
  function getFocusable() {
    return modal.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
  }
  function trapFocus() {
    lastFocused = document.activeElement;
    var focusables = getFocusable();
    if (focusables.length) focusables[0].focus();
  }
  function onKeyDown(e) {
    if (root.getAttribute('data-active') !== 'true') return;
    if (e.key === 'Escape') {
      e.preventDefault();
      track('popup_close', { reason: 'escape' });
      closeOverlay('manual');
      return;
    }
    if (e.key === 'Tab') {
      var focusables = Array.prototype.slice.call(getFocusable());
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      }
    }
  }
  document.addEventListener('keydown', onKeyDown);

  // === CLICK ON OVERLAY (outside modal) ===
  root.addEventListener('click', function (e) {
    if (e.target === root) {
      track('popup_close', { reason: 'overlay' });
      closeOverlay('manual');
    }
  });

  // === CLOSE BUTTONS ===
  closeBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var currentPhase = phase2 && !phase2.hasAttribute('hidden') ? 2 : 1;
      track('popup_close', { reason: 'button', phase: currentPhase });
      closeOverlay('manual');
    });
  });

  // === RAYON CLICK (Phase 1 → Phase 2) ===
  var phase2Titres = {};
  try { phase2Titres = JSON.parse(phase2TitresJson.textContent); } catch (e) {}

  rayonBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var rayon = btn.dataset.rayon;
      track('popup_rayon_choice', { event_label: rayon, rayon_name: rayon });
      lsSet(LS_RAYON, rayon, RAYON_DAYS);

      // Update titre phase 2
      if (phase2Title && phase2Titres[rayon]) {
        phase2Title.textContent = phase2Titres[rayon];
      }

      // Update contact[tags] hidden input avec terroir-{rayon}
      if (tagsInput) {
        var baseTags = tagsInput.dataset.baseTags || '';
        tagsInput.value = baseTags + ',terroir-' + rayon;
      }

      showPhase('2');
      setTimeout(function () {
        if (emailInput) emailInput.focus();
      }, 100);
      track('popup_view', { phase: 2 });
    });
  });

  // === FORM SUBMIT ===
  if (form) {
    form.addEventListener('submit', function (e) {
      // Honeypot check
      if (honeypot && honeypot.value) {
        e.preventDefault();
        return;
      }
      // Loading state
      if (submitBtn) submitBtn.setAttribute('data-loading', 'true');
      track('popup_submit_click', {
        event_label: lsGet(LS_RAYON) || 'unknown',
        rayon_name: lsGet(LS_RAYON) || 'unknown'
      });
      // Event normalise EI — submit avant POST
      trackEi('ei_popup_welcome_submit', 'popup_submit', { rayon: lsGet(LS_RAYON) || 'unknown' });
      // Le form natif Shopify s'occupe du reste (POST + redirect vers return_to)
    });
  }

  // === DETECT POST-SUBMIT SUCCESS (URL ?welcome=ok) ===
  function detectSuccessRedirect() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('welcome') === 'ok') {
      // Marquer comme inscrit pour ne plus afficher
      setCookie(COOKIE_SUBSCRIBED, 'true', 365);
      track('popup_submit_success', {
        event_label: lsGet(LS_RAYON) || 'unknown',
        rayon_name: lsGet(LS_RAYON) || 'unknown'
      });
      showPhase('success');
      openOverlay();
      // Auto-close apres 5s
      setTimeout(function () { closeOverlay('auto-success'); }, 5000);
      // Nettoie l'URL sans recharger
      if (window.history && window.history.replaceState) {
        params.delete('welcome');
        var newSearch = params.toString();
        var newUrl = window.location.pathname + (newSearch ? '?' + newSearch : '') + window.location.hash;
        window.history.replaceState({}, '', newUrl);
      }
      return true;
    }
    return false;
  }

  // === DETECT FORM ERRORS (Liquid render) ===
  function detectFormErrors() {
    if (errorEl && errorEl.textContent.trim()) {
      track('popup_submit_error', { event_label: 'form_error' });
      showPhase('2');
      openOverlay();
      return true;
    }
    return false;
  }

  // === MAIN INIT FLOW ===
  function init() {
    // Priorite 1 : success post-redirect
    if (detectSuccessRedirect()) return;

    // Priorite 2 : erreurs form natif
    if (detectFormErrors()) return;

    // Priorite 3 : check si deja inscrit (cas A)
    if (getCookie(COOKIE_SUBSCRIBED) === 'true') return;

    // Priorite 4 : check device visibility
    if (!isAllowedOnDevice()) return;

    // Priorite 5 : check si retour avec rayon deja choisi (cas C1)
    if (lsGet(LS_RAYON)) return;

    // Priorite 6 : check cooldown 7j (cas C2)
    var closedAt = getCookie(COOKIE_CLOSED);
    if (closedAt) {
      var elapsed = (Date.now() - parseInt(closedAt, 10)) / (1000 * 60 * 60 * 24);
      if (elapsed < COOLDOWN_DAYS) return;
    }

    // Cas B : 1ere visite ou cooldown expire → declencheurs multiples
    // (minuteur OU exit-intent desktop OU scroll mobile), une seule ouverture.
    var hasTriggered = false;

    /* ── 2026-08-19 : le consentement cookies passe TOUJOURS en premier ──
       Avant : la popup (overlay plein ecran, z-index 9998) s'ouvrait par-dessus
       le bandeau de consentement (z-index 120) et rendait Refuser/Accepter
       inaccessibles sur mobile. Double sollicitation des l'arrivee, et surtout
       un choix RGPD que le visiteur ne pouvait plus exercer tant qu'il n'avait
       pas ferme la popup. Piste serieuse pour le faible taux de reponse cookies.
       Desormais : tant que le cookie ei_consent n'existe pas, la popup patiente.
       Le declencheur est memorise et rejoue 1,5 s apres le choix du visiteur. */
    var CONSENT_COOKIE = 'ei_consent';
    var pendingTrigger = null;
    function consentDonne() { return !!getCookie(CONSENT_COOKIE); }

    var hasTriggeredGuard = false; // evite d'armer deux fois la surveillance

    function triggerPopup(triggerSource) {
      if (hasTriggered) return;
      if (!consentDonne()) {
        /* On garde le PREMIER declencheur rencontre et on laisse les
           ecouteurs en place : rien n'est perdu, tout est differe. */
        pendingTrigger = pendingTrigger || triggerSource;
        armerSurveillanceConsent();
        return;
      }
      hasTriggered = true;
      // Le popup ne s'ouvre qu'une fois → on retire les autres declencheurs
      document.documentElement.removeEventListener('mouseleave', onExitIntent);
      window.removeEventListener('scroll', onScrollTrigger);
      showPhase('1');
      openOverlay();
      track('popup_view', { phase: 1, trigger: triggerSource });
      // Event normalise EI — view a l'apparition reelle (trigger source pour mesure GA4)
      trackEi('ei_popup_welcome_view', 'popup_view', { phase: 1, trigger: triggerSource });
    }

    /* Surveillance du choix cookies. Le bandeau n'emet aucun evenement : on
       observe donc l'apparition du cookie. Sondage leger (500 ms), arrete des
       que le visiteur a tranche, et abandonne au bout de 2 min — passe ce
       delai, il ignore deliberement le bandeau, on ne l'importune pas. */
    function armerSurveillanceConsent() {
      if (hasTriggeredGuard) return;
      hasTriggeredGuard = true;
      var attendu = 0;
      var veille = setInterval(function () {
        attendu += 500;
        if (consentDonne()) {
          clearInterval(veille);
          if (pendingTrigger) {
            var source = pendingTrigger;
            /* Respiration : on laisse le bandeau disparaitre avant d'ouvrir. */
            setTimeout(function () { triggerPopup(source); }, 1500);
          }
        } else if (attendu >= 120000) {
          clearInterval(veille);
        }
      }, 500);
    }

    /* Declencheur 1 — minuteur.
       2026-09-06 : le minuteur ne s'applique plus au mobile par defaut.
       Avant, DELAI (7 s au Customizer) partait sur TOUS les appareils : sur mobile
       la pop-up plein ecran tombait pendant la lecture, avant meme que le visiteur
       ait fait defiler. C'est bloquant sur un petit ecran, et on quitte.
       Le declencheur 3 (defilement a 45 %) est deja concu pour le mobile — il ne
       servait jamais, le minuteur gagnait toujours la course.
       Desormais : sur mobile, minuteur seulement si `delai_mobile_seconds` > 0,
       en filet de securite. A 0 (defaut), c'est le defilement qui decide. */
    var DELAI_ACTIF = isMobile() ? DELAI_MOBILE : DELAI;
    if (DELAI_ACTIF > 0) {
      setTimeout(function () { triggerPopup('timer'); }, DELAI_ACTIF * 1000);
    }

    // Declencheur 2 — exit-intent desktop : la souris sort par le haut du viewport
    function onExitIntent(e) {
      if (e.clientY <= 0) triggerPopup('exit');
    }
    if (!isMobile()) {
      document.documentElement.addEventListener('mouseleave', onExitIntent);
    }

    // Declencheur 3 — scroll mobile : apres ~45% de la page (equivalent exit-intent sur mobile)
    function onScrollTrigger() {
      var docH = document.documentElement.scrollHeight - window.innerHeight;
      if (docH <= 0) return;
      if (window.scrollY / docH >= 0.45) triggerPopup('scroll');
    }
    if (isMobile()) {
      window.addEventListener('scroll', onScrollTrigger, { passive: true });
    }
  }

  // Lance apres DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
